import { render, staticRenderFns } from "./SAASForm.vue?vue&type=template&id=0c386bb5"
import script from "./SAASForm.vue?vue&type=script&lang=js"
export * from "./SAASForm.vue?vue&type=script&lang=js"
import style0 from "./SAASForm.vue?vue&type=style&index=0&id=0c386bb5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports